import { useCallback, useState } from 'react';
import { useCaseTabs } from '@lp/core/hooks/useCaseTabs';
import { Case, CaseStatus } from '@/api/apis/case';

export const useCaseCardActions = () => {
  const { openCaseDetails } = useCaseTabs();
  const [draftEditModalCase, setDraftEditModalCase] = useState<Case>();

  const onCardClick = useCallback(
    (caseInfo: Case) => () => {
      if (caseInfo.status === CaseStatus.Draft) {
        setDraftEditModalCase(caseInfo);
      } else {
        openCaseDetails(caseInfo.caseId, caseInfo);
      }
    },
    [openCaseDetails],
  );

  const closeDraftEditModal = () => setDraftEditModalCase(undefined);

  return {
    draftEditModalCase,
    onCardClick,
    onDuplicateClick: setDraftEditModalCase,
    closeDraftEditModal,
  };
};
